import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IPerfilCalculadoIn, IPerfilCuestionario, IPerfilCalculadoOut, PERFIL_MULTI_SEL, IPerfilGrabarOut, IPerfilListPerfiles } from 'src/app/services/data/actualizacion-datos/perfilamiento.model';
import { PerfilamientoService } from 'src/app/services/data/actualizacion-datos/perfilamiento.service';
import { ModalPerfilResumeComponent } from './modal-perfil-resume/modal-perfil-resume.component';
import { UserStoreService } from 'src/app/services/user/user-store.service';
import { StorageService } from 'src/app/services/storage/storage.service';

enum E_STEP_PERFIL { INIT = 1, START = 2, RESULT = 3 }

@Component({
  selector: 'app-modal-perfil-inversionista',
  templateUrl: './modal-perfil-inversionista.component.html',
  styleUrls: ['./modal-perfil-inversionista.component.scss']
})
export class ModalPerfilInversionistaComponent implements OnInit {
  isLoading: boolean = false;
  errorMessage: string = '';
  subTitle = "";
  numPagAdicional: number = 1;
  numPagNow: number = 0;
  numPagTotal: number = 0;
  readonly STEP_PERFIL = E_STEP_PERFIL;
  step: E_STEP_PERFIL = this.STEP_PERFIL.INIT;

  preguntaEdad: IPerfilCuestionario = {
    pregunta: " ¿Cuantos años tienes?",
    explicacion: "Tu edad nos ayuda a calcular un perfil más preciso.",
    multiseleccion: "N",
  } as IPerfilCuestionario;
  listCuestionario: IPerfilCuestionario[];
  isLoadingCuestionario: boolean = false;
  listPerfiles: IPerfilListPerfiles[] = [];
  resultPerfil: IPerfilCalculadoIn = {} as IPerfilCalculadoIn;
  responseCloseModal: boolean = false;

  myForm = this._fb.group({
    pais: [null],
    cliente: [null],
    edad: [null],
    preguntas: this._fb.array([]),
  });

  get frPais() { return this.myForm.get("pais") as FormControl }
  get frCliente() { return this.myForm.get("cliente") as FormControl }
  get frEdad() { return this.myForm.get("edad") as FormControl }
  get faPreguntas() { return this.myForm.get("preguntas") as FormArray }

  constructor(
    private _perfilamientoService: PerfilamientoService,
    private _dialogRef: MatDialogRef<ModalPerfilInversionistaComponent>,
    private _matDialog: MatDialog,
    private _fb: FormBuilder,
    public userStore: UserStoreService,
    private _storageService: StorageService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) { }

  ngOnInit(): void {
    this.setDataInit();
    this.getCuestionariosServ();
    this.getListPerfilesServ();
  }

  private buildPerfilCacheKey(): string {
    const documentKey = `${this.userStore.activeCUC?.cuc ?? ''}`.trim();
    return documentKey ? `perfilamientoData_${documentKey}` : 'perfilamientoData';
  }

  // SERVICES
  getCuestionariosServ() {
    this.isLoadingCuestionario = true;
    this._perfilamientoService.getCuestionario("PE").subscribe({
      next: resp => {
        if (resp.response) {
          const data = resp.data as IPerfilCuestionario | IPerfilCuestionario[];
          this.listCuestionario = Array.isArray(data) ? data : [data];
        } else {
          console.log("error");
        }
        this.isLoadingCuestionario = false;
      },
      error: () => {
        console.log("error");
        this.isLoadingCuestionario = false;
      }
    });
  }

  getListPerfilesServ() {
    this._perfilamientoService.getDescripcionPerfil("PE").subscribe({
      next: resp => {
        if (resp.response) {
          const data = resp.data as IPerfilListPerfiles | IPerfilListPerfiles[];
          this.listPerfiles = Array.isArray(data) ? data : [data];


        }
         const orden = ['CONSERVADOR', 'MODERADO', 'AGRESIVO'];

        this.listPerfiles.sort(
          (a, b) => orden.indexOf(a.codigo) - orden.indexOf(b.codigo)
        );
      },
    });
  }

  getCalcularPerfilServ(dataOut: IPerfilCalculadoOut) {
    this.errorMessage = '';
    this.isLoading = true;
    this._perfilamientoService.getCalcularPerfil(dataOut).subscribe({
      next: resp => {
        if (resp.response) {
          this.setDataResult(resp.data);
          const idCalculo = (resp as any).idcalculo ?? (resp.data as any)?.idcalculo;
          this.grabarPerfilServ(this.buildDataGrabar(idCalculo));
        } else {
          this.isLoading = false;
          this.errorMessage = 'No se pudo calcular el perfil. Intente nuevamente.';
        }
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'Error de comunicación al calcular el perfil. Verifique su conexión.';
      }
    });
  }

  private guardarPerfilEnCacheDesdeApi() {
    const cacheKey = this.buildPerfilCacheKey();

    this._perfilamientoService.getConsultarPerfil( this.userStore.activeCUC.cuc, 'PE').subscribe({
      next: resp => {
        if (resp?.response && resp.data) {


           if(resp.data.idperfil_aceptado == "AGRESIVO"){
            resp.data.idperfil_aceptado = "DINÁMICO";
          }
          this._storageService.storePerfilamientoData(resp.data, cacheKey).subscribe();
        }
      },
      error: () => {
        console.error('No se pudo actualizar el perfil persistido desde el modal.');
      }
    });
  }

  grabarPerfilServ(dataOut: IPerfilGrabarOut) {
    this.errorMessage = '';
    this._perfilamientoService.grabarPerfil(dataOut).subscribe({
      next: resp => {
        this.isLoading = false;
        if (resp.response){ 
            this.responseCloseModal = true;
            this.guardarPerfilEnCacheDesdeApi();
            this._perfilamientoService.enviarCorreoEmail(dataOut.nombre, this.userStore.activeCUC?.cuc ?? '', dataOut.idperfil_aceptado).subscribe({
              next: resp => {
                if (resp.response) {  
                }
              }
            });
        }
                
        else this.errorMessage = 'No se pudo guardar el resultado del perfil.';
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'Error de comunicación al guardar el perfil. Intente nuevamente.';
      }
    });
  }

  // BOTONES
  btnStart() { this.setDataStart(); }
  btnClose() { this._dialogRef.close(this.responseCloseModal); }
  btnBack() {
    if (this.numPagNow <= 1) {
      this.setDataInit();
    } else {
      this.numPagNow--;
    }
  }

  btnNext() {
    if (this.numPagNow === this.numPagTotal) {
      this.getCalcularPerfilServ(this.buildCuestionarioOut);
    } else {
      this.numPagNow++;
    }
  }

  btnShowResume(item: IPerfilCuestionario) {
    this._matDialog.open(ModalPerfilResumeComponent, {
      height: 'auto',
      width: '700px',
      disableClose: true,
      data: { title: item.pregunta, resume: item.explicacion }
    });
  }

  // LOGICA
  setDataInit() {
    this.subTitle = "Calcula tu perfil de inversionista";
    this.step = this.STEP_PERFIL.INIT;
    this.numPagNow = 0;
    this.myForm.reset();
    this.faPreguntas.clear();
    this.frPais.setValue("PE");
    this.frCliente.setValue("");
    this.resultPerfil = {} as IPerfilCalculadoIn;
  }

  setDataStart() {
    if (!this.listCuestionario?.length || this.isLoadingCuestionario) {
      return;
    }

    this.subTitle = "Calcula tu perfil de inversionista y recibe una mejor asesoria.";
    this.numPagNow = 1;
    this.step = this.STEP_PERFIL.START;
    this.buildCuestionario(this.listCuestionario);
  }

  setDataResult(dataIn: IPerfilCalculadoIn) {
    this.resultPerfil = dataIn;
    this.step = this.STEP_PERFIL.RESULT;
  }

  buildCuestionario(cuestionario: IPerfilCuestionario[]) {
    this.listCuestionario = cuestionario;
    this.numPagTotal = this.listCuestionario.length + this.numPagAdicional;
    this.listCuestionario.forEach(x => this.addPregunta(x));
  }

  get buildCuestionarioOut(): IPerfilCalculadoOut {
    return {
      idpais: this.frPais.value,
      edad: Number(this.frEdad.value),
      idcliente: this.frCliente.value,
      repuestas: this.faPreguntas.getRawValue().map(x => {
        return {
          idtipopregunta: x.idPregunta,
          idtiporespuestapregunta: x.isMulti ? x.respuestaMulti.filter(x => x.isCheck).map(y => y.id).join(";") : x.respuesta
        }
      })
    }
  }

  buildDataGrabar(idCalculo: string): IPerfilGrabarOut {
    return {
      idcalculo: idCalculo,
      idpais: this.resultPerfil.idpais,
      idcliente: this.frCliente.value,
      nombre: this.userStore.nombres ?? "",
      apellido:  this.userStore.apellidos ?? "",
      idcanal: "WF_PE",
      idperfil_calculado: this.resultPerfil.idperfil,
      idperfil_aceptado: this.resultPerfil.idperfil,
      generadorpor: "CLIENTE",
    }
  }

  // FUNCIONES
  addPregunta(preguntaIn: IPerfilCuestionario) {
    this.faPreguntas.push(this._fb.group({
      idPregunta: [preguntaIn.idtipopregunta],
      respuesta: [null, preguntaIn.multiseleccion === PERFIL_MULTI_SEL.N ? [Validators.required] : []],
      respuestaMulti: this._fb.array(preguntaIn.tiporespuestapregunta.map(x => this._fb.group({ id: x.idtiporespuestapregunta, isCheck: false }))),
      isMulti: [preguntaIn.multiseleccion === PERFIL_MULTI_SEL.S],
    }))
  }
}
